import * as React from "react";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

export default function SwitchLabel({ checked, onChangeFun, name = "", inputProps }) {
  return (
    <FormControlLabel
      control={
        <Switch
          checked={checked}
          onChange={onChangeFun}
          name={name}
          inputProps={inputProps}
          sx={{
            "& .MuiSwitch-switchBase.Mui-checked": {
              color: "var(--qv-brand)",
            },
            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
              backgroundColor: "var(--qv-brand)",
              opacity: 1,
            },
          }}
        />
      }
    />
  );
}
